




















































































import Vue from 'vue'
import { ToggleSwitch } from '@raksul/raksul-common-ui'

import ProductInfo from '@/groupBuy/components/ProductInfo.vue'

import {
  PrintableSku
} from '@/groupBuy/types'
import { COLOR_PATTERN_TYPES } from '@/common/constants'

export default Vue.extend({
  components: {
    ProductInfo,
    ToggleSwitch
  },
  props: {
    product: {
      type: Object as () => PrintableSku,
      required: true
    },
    acceptingInput: {
      type: Boolean,
      default: false
    },
    validQuantity: {
      type: Boolean,
      required: true
    },
    totalQuantity: {
      type: String,
      required: true
    },
    disabledAction: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isPrintableSku(): boolean {
      return this.product.sku.skuColorPatterns.some(item => item.colorPattern.type !== COLOR_PATTERN_TYPES.PLAIN)
    },
    isPlainPsi(): boolean {
      return this.product.skuColorPattern.colorPattern.type == COLOR_PATTERN_TYPES.PLAIN
    },
    disableActions(): boolean {
      return this.disabledAction || this.acceptingInput || !this.validQuantity
    }
  },
  methods: {
    onChangeRequestStatus() {
      this.$emit('toggleAcceptingInput', !this.acceptingInput)
    },
    addToCart() {
      this.$emit('addToCart')
    }
  }
})
